export default __webpack_public_path__ + "static/media/sale-month.7f4a72a6.svg";